import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMouse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMouse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1bb242dc8d2a09633090792e3739643916ead756', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1b6f1b2348b01c97635344799b289b9ba7fdaa1a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a64f954f33243f9e953b70c830925e4c51900d18', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 4a3.78 3.78 0 0 0-4 3.54v6.92A3.73 3.73 0 0 0 11 18a3.7 3.7 0 0 0 4-3.79V7.77A3.69 3.69 0 0 0 11 4m0 4.25a1.25 1.25 0 1 1 .02-2.5 1.25 1.25 0 0 1-.02 2.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-mouse", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mouse"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mouse":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMouse$1);
            }
            break;
    } });
}

const CosmosIconMouse = CosmosIconMouse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMouse, defineCustomElement };
